import { format } from "date-fns";
import styles from "../../styles/_containers/_giftCards/table.module.scss";

const Table = ({ data }) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2>Gift Cards Consumption History</h2>
      </div>
      <div className={styles.tableWrapper}>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Code</th>
              <th>Balance Used</th>
              <th>Service</th>
              <th>Service Amount</th>
              <th>Consumer</th>
              <th>Used At</th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 && (
              <tr>
                <td colSpan={10}>
                  <p>There are no consumers yet</p>
                </td>
              </tr>
            )}
            {data.map((i) => (
              <tr key={i._id}>
                <td>{i.userGiftCardId?.giftCardId.name}</td>
                <td>{i.userGiftCardId?.code}</td>
                <td>₪{i.balanceUsed}</td>
                <td>{i.serviceName}</td>
                <td>₪{i.serviceAmountOriginal}</td>
                <td>{i.userId.name}</td>
                <td>{format(new Date(i.createdAt), "dd/MM/yyyy")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
